import { useAppSelector } from '../../redux/hook';
import { Helpers } from '../../utils/helper';
import { useCallback, useEffect, useMemo } from 'react';
import useCheckTokenExpiry from '../../hooks/use-check-token-expiry';
import OldHeader from './old-header';
import config from '../../config';
import { P2Masthead } from 'react-bootstrap-common-script';
import { PolymerAxios } from '../../utils/axios';

function Header() {
  const isAuthenticated = useAppSelector(state => state.auth.AuthenticationSlice.isAuthenticated);
  const isSingPass = useAppSelector(state => state.auth.AuthenticationSlice.isSingPass);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const applicationCooDashboardCard = document.querySelector(".polymer-application-coo-dashboard__card") as HTMLDivElement;
  
  useCheckTokenExpiry();

  const handleOnClick = useCallback(() => {
    if(isSingPass){
      window.location.href = "/transfer/logout?spToken=" + singpassToken;
    }else{
      console.error("enter else");
      Helpers.clearAuthPersistData();
      Helpers.clearPersistData();
      window.location.href = "/transfer";
    }
  }, [isSingPass, singpassToken])


  const adjustHeaderPosition = useCallback(() => {
    const applicationCooCard = document.querySelector(".polymer-application-coo__card") as HTMLDivElement;
    const landingContainer = document.querySelector(".container") as HTMLAnchorElement;
    const element = applicationCooDashboardCard ?? applicationCooCard ?? landingContainer;
    let left = element?.getBoundingClientRect().left ?? 0;
    let width = element?.clientWidth ?? 0;

    if(left === 0){
      left = 0;
    }
    
    const polymerHeaderMargin = document.querySelector(".polymer-header-margin") as HTMLDivElement;
    const polymerMastheadInner = document.querySelector(".polymer-masthead-inner") as HTMLDivElement;
    const polymerMastheadWrapper = document.querySelector(".polymer-masthead") as HTMLDivElement;
    if(polymerMastheadWrapper){
        polymerMastheadWrapper.style.justifyContent = "unset";
    }

    if(polymerHeaderMargin){
      // polymerHeaderMargin.style.width = "0";
   }

   if(polymerMastheadInner){
    // polymerMastheadInner.style.padding = "0";
   }

    const mastheadContainer = document.querySelector("sgds-masthead")?.shadowRoot?.querySelector("#sgds-masthead") as HTMLDivElement | null;
    const masthead = document.querySelector("sgds-masthead")?.shadowRoot?.querySelector(".container") as HTMLDivElement | null;
    const mastheadContent = document.querySelector("sgds-masthead")?.shadowRoot?.querySelector("#sgds-masthead-content") as HTMLDivElement | null;
    const siteLogo = document.querySelector(".polymer-site-logo") as HTMLDivElement | null;
    if(masthead){
      mastheadContainer?.setAttribute("role", "navigation");
      masthead.style.padding = `0 0 0 0`;
      
     const mastheadExpandButton =  masthead.querySelector(".sgds-masthead-button") as HTMLSpanElement | null;
     const mastheadExpandText =  masthead.querySelector(".sgds-masthead-button-text") as HTMLSpanElement | null;
     const mastheadExpandArrow = masthead.querySelector(".sgds-masthead-identify-icon") as SVGElement | null;
     const mastheadExpandArrowPath = mastheadExpandArrow?.querySelector("path") as SVGPathElement | null;
     if(mastheadExpandButton && mastheadExpandText && mastheadExpandArrow && mastheadExpandArrowPath){
      const nonHoverColor = "#2F60CE";
      const hoverColor = "#23489B";
      mastheadExpandText.style.color = nonHoverColor;
      mastheadExpandArrow.style.fill = nonHoverColor;
      mastheadExpandArrowPath.style.fill = nonHoverColor;
      mastheadExpandButton.onmouseover = function () {
        mastheadExpandText.style.color = hoverColor;
        mastheadExpandArrow.style.fill = hoverColor;
        mastheadExpandArrowPath.style.fill = hoverColor;
      }

      mastheadExpandButton.onmouseleave = function () {
        mastheadExpandText.style.color = nonHoverColor;
        mastheadExpandArrow.style.fill = nonHoverColor;
        mastheadExpandArrowPath.style.fill = nonHoverColor;
      }
     }
    }

    if(mastheadContent){
      mastheadContent.style.paddingLeft = `${left}px`;
    }

    if(siteLogo){
      // siteLogo.style.marginLeft = `${left}px`;
    }

    const loginContainer = document.querySelector(".old-header-login-container") as HTMLDivElement | null;
    const navBar = document.querySelector(".old-header-primary-nav");
    const warningContainer = document.querySelector(".old-header-warning-container") as HTMLDivElement | null;
    const displayItemButton = document.querySelector(".polymer-header-item");
    const closeDisplayItemButton = document.querySelector(".polymer-header-item-cross");
    const logoMarginRight = getComputedStyle(siteLogo!).marginRight;
    const marginRight = logoMarginRight?.length > 0 ? Number(logoMarginRight.substring(0, logoMarginRight.length - 2)) : 0;
    if(loginContainer){
      let warningLogoPaddingRight = 0;
      if(window.innerWidth >= 1366){
        warningLogoPaddingRight = 96;
      }else if(window.innerWidth >= 993){
        warningLogoPaddingRight = 48;
      }

      if(warningContainer){
        warningContainer.style.paddingRight = `0px`;
      }
      loginContainer.style.width = `${(width - (siteLogo?.clientWidth ?? 0) - marginRight - (navBar?.clientWidth ?? 0) - (displayItemButton?.clientWidth ?? closeDisplayItemButton?.clientWidth ?? 0) - ((warningContainer?.clientWidth ?? 0) + warningLogoPaddingRight))}px`;
    }

    const searchBar = document.querySelector(".search-bar") as HTMLInputElement | null;
    const siteSearchWrapperMargin = document.querySelector(".site-search > .wrapper-margin") as HTMLDivElement | null;
    if(searchBar && siteSearchWrapperMargin){
      searchBar.style.minWidth = `${width - 60 - 96}px`;
      siteSearchWrapperMargin.style.margin = `0 0 0 ${left + 48}px`;
    }

    const headerAlertContainer = document.querySelector(".polymer-header-alert-container") as HTMLDivElement | null;
    if(headerAlertContainer && warningContainer){
      let warningPaddingRight = getComputedStyle(warningContainer).paddingRight ?? "0";
      if(window.innerWidth <= 1025){
          headerAlertContainer.style.marginTop = "24px";
      }

      if(window.innerWidth <= 992){
        warningContainer.style.paddingRight = "0";
        warningPaddingRight = "0";
      }

      headerAlertContainer.style.marginRight = `${warningPaddingRight}`;
    }
  
  },[applicationCooDashboardCard])

  useEffect(() => {
  setTimeout(() => {
    adjustHeaderPosition();
    const article = document.querySelector("sgds-masthead")?.shadowRoot?.querySelector("article") as HTMLDivElement | null;

    if(article){
      const anchorTag = article.querySelector("a");
      if(anchorTag){
        article.innerHTML = `Government agencies communicate via <strong>.gov.sg</strong> websites (e.g. go.gov.sg/open).${anchorTag.outerHTML}`;
      }
    }
  }, 100)
   window.addEventListener("resize", adjustHeaderPosition);

   return () => window.removeEventListener("resize", adjustHeaderPosition);

  }, [applicationCooDashboardCard, adjustHeaderPosition])
  
  return (
    <div id="p2-header">
      <P2Masthead/>
      <OldHeader isAuth={isAuthenticated} onClick={handleOnClick}/>
    </div>
  )
}

export default Header
